import { faFileLines } from "@fortawesome/pro-duotone-svg-icons/faFileLines";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_PROMPTS_LINK: Breadcrumb = {
  icon: faFileLines,
  name: "Prompts",
  to: "/dashboard/prompts",
};
